<template>
  <div>
    <div class="page page__list" v-if="!isS2S">
      <search-bar
        @search="onSearch"
        name="ma_code,ma_prodcode,pr_detail,pr_orispeccode,ma_salecode,ma_vendcode,ma_vendname"
        placeholder="输入制造单号、外协厂商、产品进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.ma_id"
          :to="'/out_prod/make/'+item.ma_id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ma_prdetail}}</p>
            <p class="list-item-muted">{{item.createTime}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ma_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.ma_status!='已审核'}"
            >{{item.ma_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}张</label>
      </div>
    </div>
    <div class="page page__list" v-if="isS2S">
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.pi_id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.ve_name}}</p>
            <p class="list-item-muted">{{item.pi_inoutno}}</p>
          </div>
          <div class="weui-cell__ft">
            <p v-format="'yyyy-MM-dd'">{{item.pi_date}}</p>
            <p class="list-item-muted" v-if="item.expressInfo">{{item.expressInfo.expressInc}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isS2S: false,
      listUrl: "/api/make/make/list",
      filters: [
        {
          type: "date",
          name: "make.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "ma_tasktype='OS'"
            },
            {
              value: 1,
              label: "待收货",
              condition: ""
            },
            {
              value: 2,
              label: "待领料",
              condition:
                "ma_tasktype='OS' and ifnull(ma_getstatus,' ') in(' ','部分领料')"
            },
            {
              value: 3,
              label: "待完工",
              condition:
                "ma_tasktype='OS' AND ifnull(ma_madeqty,0)>ma_qty and ma_statuscode='AUDITED'"
            },
            {
              value: 4,
              label: "已完工",
              condition: "ma_tasktype='OS' AND ifnull(ma_madeqty,0)>ma_qty"
            },
            {
              value: 5,
              label: "已结案",
              condition: "ma_tasktype='OS' AND ma_statuscode='FINISH'"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isS2S = filter.value == 1
      this.listUrl = isS2S ? '/api/make/make/S2STurnOsMakeIn/list' : '/api/make/make/list'
      this.filters[0].name = isS2S ? 'pi_date' : 'make.createTime'
      this.isS2S = isS2S
      filterBar.initConfig()
      next()
    },
    gotoView(item) {
      this.$router.push({
        name: "OutProductionS2STurnOsMakeIn",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
  }
};
</script>